import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

function pageNumbers(page, totalPages) {
  const pages = new Set([1, totalPages, page - 1, page, page + 1]);
  return [...pages].filter((p) => p >= 1 && p <= totalPages).sort((a, b) => a - b);
}

// Shared numbered page control for every list/table screen (Pagination
// Across All List Screens, Sep 2026). Renders nothing for a single page.
export function PaginationBar({ page, totalPages, onPageChange, testId = "pagination-bar" }) {
  if (!totalPages || totalPages <= 1) return null;
  const nums = pageNumbers(page, totalPages);

  return (
    <Pagination data-testid={testId} className="pt-2 justify-start">
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            data-testid={`${testId}-prev`}
            onClick={() => page > 1 && onPageChange(page - 1)}
            className={page <= 1 ? "pointer-events-none opacity-40" : "cursor-pointer"}
          />
        </PaginationItem>
        {nums.flatMap((p, i) => {
          const els = [];
          if (i > 0 && nums[i - 1] !== p - 1) {
            els.push(
              <PaginationItem key={`ellipsis-${p}`}>
                <PaginationEllipsis />
              </PaginationItem>
            );
          }
          els.push(
            <PaginationItem key={p}>
              <PaginationLink
                data-testid={`${testId}-page-${p}`}
                isActive={p === page}
                onClick={() => onPageChange(p)}
                className={
                  p === page
                    ? "bg-amber-600 border-amber-600 text-white hover:bg-amber-700 hover:text-white cursor-pointer"
                    : "cursor-pointer"
                }
              >
                {p}
              </PaginationLink>
            </PaginationItem>
          );
          return els;
        })}
        <PaginationItem>
          <PaginationNext
            data-testid={`${testId}-next`}
            onClick={() => page < totalPages && onPageChange(page + 1)}
            className={page >= totalPages ? "pointer-events-none opacity-40" : "cursor-pointer"}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}
